/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { useFeatureFlag } from '@/features/globalConfig';
import { getProductReviewsURL } from '@/features/product';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { useLabels } from '@/hooks/useLabels';
import { Actionable, Divider, Icon, Text } from '@az/starc-ui';
import { ArrowRight } from '@az/starc-ui-icons';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';

const labelMap = {
  seeMoreReviews: 'label_reviews_seeMoreReviews',
  for: 'label_for',
};

export const PRPLink = () => {
  const productReviewsEnabled = useFeatureFlag('PRP_ENABLED') === 'true';
  const router = useLegacyRouter();
  const labels = useLabels(labelMap);

  const { data: productDetailsData, isSuccess: productDetailsReqIsSuccess } = useProductDetails({
    enabled: false,
  });

  const productReviewsURL =
    productReviewsEnabled && Array.isArray(router.query.slug)
      ? `${getProductReviewsURL(router.query.slug.join('/'))}`
      : undefined;

  if (!productDetailsReqIsSuccess || !productReviewsEnabled || !productReviewsURL) {
    return null;
  }

  return (
    <div>
      <Divider />
      <FlexGrid
        className={styles.container}
        flexDirection="row"
        justifyContent="center"
        gap={{ sm: 4, md: 5 }}
      >
        <Actionable className={styles.seeMoreReviews} href={productReviewsURL}>
          <Text variant="small-body">
            <span className={styles.link}>{labels.seeMoreReviews}</span>
            <span>{` ${labels.for} ${productDetailsData.product?.itemDescription}`}</span>
          </Text>
          <Icon svg={ArrowRight} size={6} color="accent" />
        </Actionable>
      </FlexGrid>
    </div>
  );
};
